module.exports = __webpack_public_path__ + "static/media/009.6e881645.jpg";